import Axios from '@/common/require'
export default {
  GET_TRAIN_LIST(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/train/index',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
    
  },
  // 下载
  DOWNLOAD_TRAIN_FILE(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/train/download',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
    
  },
  // 获取oss下载地址
  GET_OSS_DOWNLOADURL(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/train/download',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0,
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 上传资料
  UPLOAD_TRAIN_FILE(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/train/upload',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0,
          file: 1
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
    
  },
  // 新建资料
  CREATE_TRAIN(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/train/create',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
    
  },
  // 更新资料
  UPDATE_TRAIN(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/train/update',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
    
  },
  // 删除资料
  DEL_TRAIN(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/train/delete',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
    
  },
  // 获取资料详情
  GET_TRAIN_INFO(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/train/info',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
    
  },


  // 科目
  // 树
  GET_SUBJECT_LIST(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/api/index/type_list',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
    
  },
  // 下拉列表
  GET_SUBJECT_SELECT(store,data){
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/api/index/subjects',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  CREATE_SUBJECT(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/train/sub_create',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
    
  },
  UPDATE_SUBJECT(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/train/sub_update',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
    
  },
  DEL_SUBJECT(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/train/sub_delete',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  GET_SUBJECT_INFO(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/subject/info',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 培训资料
  GET_RESOURCE_LIST(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/resource/index',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 培训资料详情
  GET_RESOURCE_INFO(store,data) {
    return new Promise((resolve, reject) => {
      Axios({
        url: '/api.php/console/resource/info',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
}


// WEBPACK FOOTER //
// ./src/store/modules/train/actions.js